import { render, staticRenderFns } from "./validation.vue?vue&type=template&id=1b25165d&"
import script from "./validation.vue?vue&type=script&lang=js&"
export * from "./validation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports